import { createElementBlock as a, openBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function n(r, l) {
  return e(), a("svg", o, [...l[0] || (l[0] = [
    t("path", {
      fill: "currentColor",
      d: "M13.079 1.753a.9.9 0 0 0-.427.09L10.5 2.894 8.347 1.842a.874.874 0 0 0-1.152.368L6.029 4.348l-2.36.413a.876.876 0 0 0-.716.974l.313 2.415L1.6 9.871a.876.876 0 0 0-.007 1.21l1.673 1.769-.335 2.372a.875.875 0 0 0 .704.983l2.394.447 1.123 2.116a.87.87 0 0 0 1.147.381l2.2-1.044h.001l2.152 1.053a.873.873 0 0 0 1.152-.366l1.165-2.138 2.36-.415c.46-.08.776-.51.716-.974l-.31-2.413 1.664-1.723a.874.874 0 0 0 .006-1.208l-1.67-1.77.334-2.373a.876.876 0 0 0-.706-.983l-2.392-.447-1.123-2.116a1 1 0 0 0-.35-.359.9.9 0 0 0-.42-.12Zm-.395 2.019.94 1.774a.87.87 0 0 0 .622.45l1.972.365-.277 1.969a.87.87 0 0 0 .236.73l1.381 1.454-1.083 1.12-.298.308a.87.87 0 0 0-.236.73l.262 1.988-1.957.343a.88.88 0 0 0-.62.451l-.957 1.766-1.786-.874a.88.88 0 0 0-.767 0l-1.81.865-.932-1.757a.87.87 0 0 0-.62-.45l-1.972-.365.277-1.965a.87.87 0 0 0-.238-.733l-1.38-1.453 1.38-1.427a.88.88 0 0 0 .238-.733L4.795 6.34l1.959-.343a.87.87 0 0 0 .62-.451L8.33 3.78l1.786.874a.88.88 0 0 0 .767 0zm-.082 2.835L7.35 13.605l1.049.788 5.253-6.998zM8.312 7a1.313 1.313 0 1 0 .001 2.626 1.313 1.313 0 0 0 0-2.626Zm4.376 4.375a1.313 1.313 0 1 0 0 2.626 1.313 1.313 0 0 0 0-2.626"
    }, null, -1)
  ])]);
}
const m = { render: n };
export {
  m as default,
  n as render
};
